<template>
    <div :class="{ 'shadow-button row items-center text-center cursor-pointer': true, 'bg-normal': !focused, 'bg-focused': focused, 'bg-grey cursor-default no-pointer-events': disabled }" @mouseenter="focused = true" @mouseleave="focused = false">
        <!--
        @click.capture.stop.prevent="click"
        <div class="col-auto">
            <q-img src="~assets/ui/icons/telegram-icon.png" style="height: 42px; width: 42px; margin-right: 10px; margin-left: 3px;" />
        </div>
        -->
        <div v-show="!loading" class="col text-subtitle1" :style="{ 'color': textColor }">
            {{ label }}
        </div>
        <div v-show="loading" class="flex flex-center items-center row col">
            <q-circular-progress indeterminate size="sm" color="white" />
        </div>
    </div>
</template>

<script>
export default {
    name: 'DefaultButton',
    props: {
        label: {
            type: String,
            default: undefined,
        },
        textColor: {
            type: String,
            default: 'white',
        },
        disabled: {
            type: Boolean,
            default: false,
        },
        loading: {
            type: Boolean,
            default: false,
        },
    },
    data () {
        return {
            focused: false,
            clicked: false,
        };
    },
    methods: {
        click (event) {
            if (this.clicked) {
                return;
            }
            if (this.disabled || this.loading) {
                event.stopPropagation();
                return;
            }
            this.clicked = true;
            event.stopPropagation();
            this.$emit('click');
            this.$nextTick(() => {
                this.clicked = false;
            });
        },
    },
};
</script>

<style scoped lang="scss">
    .shadow-button {
        border-radius: 16px;
        height: 48px;
        // box-shadow: 0 0 5px #cfcfcf;
    }
    .bg-normal {
        background-color: #FF8577;
    }
    .bg-focused {
        background-color: #FF4833;
    }
</style>
